import { ClientProxy } from '../../../../../base/proxy/clientProxy'
import { IRequesterInfo } from '../../../../../base/models'

export class DeleteProductColorApi extends ClientProxy {
  constructor(requesterInfo: IRequesterInfo) {
    super({
      url: 'admin/color/deleteColor/',
      requesterInfo,
    })
  }

  public async deleteProductColor(id: number): Promise<any> {
    this.props.url = `${this.props.url}${id}`
    return await this.deleteAsync<any>()
  }
}
